import React from 'react';
import fire from '../../../auth/firebase';
import '../../styles/styles.css';

export class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            alertShow: false,
            setShow: '',
            isFailure: false,
            errMessage: '',
            successMessage: '',
            emailError: '',
            email: '',
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.clearInputs = this.clearInputs.bind(this);
        this.clearError = this.clearErrors.bind(this);
    }


    clearInputs() {
        this.setState({ email: '', password: '', confirmPassword: '' })
    }

    clearErrors() {
        this.setState({ emailError: '', passwordError: '', confirmPasswordError: '', successMessage: '' })
    }

    onChange(e) {
        this.clearErrors()
        console.log(e.target.name);
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmit(e) {
        console.log(this.state.email);
        e.preventDefault();
        const user = {
            email: this.state.email,
        };

        fire
            .auth()
            .sendPasswordResetEmail(user.email)
            .then(res => {
                this.setState({ successMessage: 'Email was sent, please follow the instructions in the mail', isFailure: false, alertShow: true });
                console.log(res);
                this.clearInputs()
            })
            .catch(error => {
                console.log(error);
                // eslint-disable-next-line default-case
                switch (error.code) {
                    case "auth/invalid-email":
                    case "auth/user-disabled":
                    case "auth/user-not-found":
                        this.setState({ emailError: error.message, isFailure: true, alertShow: true });
                        break;
                    case "auth/wrong-password":
                        this.setState({ passwordError: error.message, isFailure: true, alertShow: true });
                        break;
                }
            });

    }

    render() {

        return (
            <section className="login">
                <div className="loginContainer">
                    <label>Email</label>
                    <input
                        type="text"
                        name="email"
                        autoFocus
                        required
                        value={this.email}
                        onChange={e => this.onChange(e)}
                    />
                    <p className="errorMsg">{this.state.emailError}</p>
                    <p className="successMsg">{this.state.successMessage}</p>

                    <div className="btnContainer">
                        <>
                            <button onClick={this.onSubmit}>Reset password</button>
                            <p>
                                Don't have an account?
                            <span onClick={() => window.location.href = '/register'}>Sign up</span>
                            </p>
                            <p>
                                Have an account?
                            <span onClick={() => window.location.href = '/'}>Sign in</span>
                            </p>
                        </>
                    </div>
                </div>
            </section>
        )
    }
}